// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".discount-info p a{color:#fff;text-decoration:none;font-family:\"Ciutadella W04 Medium\",\"Ciutadella\",sans-serif;font-weight:500}", ""]);
// Exports
module.exports = exports;
